<template>
    <div class="box">
        <!--..右侧盒子..-->
        <div class="me_shoucang">
            <div class="shouc_tit">
                <p style="color: #39bf3e;border-bottom: 3px solid #39BF3E;" class="shouc_tit_word">文章</p>
                <p class="shouc_tit_course">课程</p>
            </div>
            <!--...商品..-->
           

            <!--...文章...-->
            <div class="shouc_word" v-loading="inforloading">
                <div class="shouc_word_sont" v-if="infor.length">
                    <div class="shuoc_word_box" v-for="item in infor" :key="item.id">
                        <div class="shouc_word_time">
                            <p>{{ $util.timeStampTurnTime(item.createtime, 'DD') }}</p>
                            <p>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM') }}</p>
                        </div>
                        <div class="shouc_word_p">
                            <a :href="'/information/details?id='+item.id">{{item.title}}</a>
                            <p>{{item.content}}</p>
                        </div>
                    </div>
                </div>
                <!--...分页..-->
                <div class="pages" v-if="infor.length">
                    <div class="Pagination Pagination_infor"></div>
                     <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
                </div>
                <div v-if="!inforloading && !infor.length" style="text-align: center;margin-top: 20px;">您还没有收藏文章哦</div>
            </div>

            <!--..课程..-->
            <div class="shouc_course" v-loading="courseloading">
                <div class="shouc_course_cont" v-if="course.length">
                    <div class="shouc_course_box" v-for="item in course" :key="item.id">
                        <a :href="'/agricultural/coursedetails?id='+item.id" class="course_a">
                            <img :src="$util.img(item.image)" alt="">
                            <img src="@/assets/styles/picture/me_img17.png" class="course_hover" alt="">
                        </a>
                        <div class="course_p">
                            <p>{{item.name}}</p>
                            <p><span>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</span><span>{{item.click_count}}人观看</span></p>
                        </div>
                    </div>
                </div>
                <!--...分页..-->
                <div class="pages" v-if="course.length">
                    <div class="Pagination Pagination_course"></div>
                     <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
                </div>
                <div v-if="!courseloading && !course.length" style="text-align: center;margin-top: 20px;">您还没有收藏课程哦</div>
            </div>
        </div>
    </div>
</template>

<script>

    import '@/assets/styles/css/common.css';
    import '@/assets/styles/css/me.css';
    import '@/assets/styles/js/jquery.pagination.js';
    import { information_MyPage } from '@/api/information/information';
    import { Course_MyPage } from '@/api/course/course';

    export default {
        name: "",
        components: {},
        data: () => {
            return {
                pageCount_infor:0,
                page_size_infor:3,
                page_infor:1,
                infor:[],
                inforloading:true,

                pageCount_course:0,
                page_size_course:10,
                page_course:1,
                course:[],
                courseloading:true,
            }
        },
        created() {
            this.getInfor();
            this.getCourse();
        },
        methods: {
            getInfor(){
                information_MyPage({
                    page_size: this.page_size_infor,
                    page: this.page_infor,
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount_infor = res.data.page_count;
                        $(".Pagination_infor").pagination(this.pageCount_infor, {
                            callback: this.changeinfor
                        });
                        this.infor = res.data.list;
                        this.inforloading = false;
                    }
                });
            },
            getCourse(){
                Course_MyPage({
                    page_size: this.page_size_course,
                    page: this.page_course,
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount_course = res.data.page_count;
                        $(".Pagination_course").pagination(this.pageCount_course, {
                            callback: this.changecourse
                        });
                        this.course = res.data.list;
                        this.courseloading = false;
                    }
                });
            },
            changeinfor(page_id) {
                this.inforloading = true;
                this.page_infor = page_id + 1;
                information_MyPage({
                    page_size: this.page_size_infor,
                    page: this.page_infor,
                }).then(res => {
                    if(res.code == 0) {
                        this.infor = res.data.list;
                        this.inforloading = false;
                    }
                });
            },
            changecourse(page_id) {
                this.courseloading = true;
                this.page_course = page_id + 1;
                information_MyPage({
                    page_size: this.page_size_course,
                    page: this.page_course,
                }).then(res => {
                    if(res.code == 0) {
                        this.course = res.data.list;
                        this.courseloading = false;
                    }
                });
            },
        },
        mounted() {
            $(function(){
         
            //...点击文章....
                $(".shouc_tit_word").click(function(){
                    $('.shouc_word').css({display:'block'})
                    $('.shouc_course').css({display:'none'})
                    $(this).css({'color': "#39bf3e",'border-bottom': "3px solid #39BF3E"})
                    $(".shouc_tit_course").css({'color': "#333333",'border-bottom': "none"})
                });	
            //...点击课程....
                $(".shouc_tit_course").click(function(){
                    $('.shouc_course').css({display:'block'})
                    $('.shouc_word').css({display:'none'})
                    $(".shouc_tit_course").css({'color': "#39bf3e",'border-bottom': "3px solid #39BF3E"})
                    $(".shouc_tit_word").css({'color': "#333333",'border-bottom': "none"})
                });		


            })

            //...划过课程...
            $(".course_a").each(function(){
                $(this).hover(
                    function(){
                        $(this).children('.course_hover').fadeIn(100)
                    },
                    function(){
                        $(this).children('.course_hover').fadeOut(10)
                    }
                )
            })
		},
    }
</script>